import React, { useState, useEffect, useLayoutEffect  } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './style.css';
import { useRef } from 'react';


export const Form = () => {
    const navigate = useNavigate();

    //ブラウザのタブに表示されるタイトルを設定
    useEffect(() => {
        document.title = "評価依頼表";
      }, []);

    const { search } = useLocation(); // URLからクエリパラメータの取得
    const URLqueryParams = new URLSearchParams(search);
    const unique = URLqueryParams.get('unique');
    if(sessionStorage.getItem('ID') != null){
        console.log("unique_query;",unique);
        sessionStorage.setItem('Unique',unique);
    }

    const auth = sessionStorage.getItem('ID');
    //ログインしていない場合はリダイレクト
    useEffect(() => {
      if (!auth) {
        navigate('/login');
      }
    }, [auth, navigate]);
    
    //Uniqueがクエリにない場合はListへリダイレクト
    const [alertShown, setAlertShown] = useState(false);
    useEffect(() => {
        const status = sessionStorage.getItem('Status');
        if (!status && !unique && !alertShown) {
            setAlertShown(true); // アラートを表示したことを記録
            alert("リストから新規作成か依頼Noを開いてください");
            navigate('/list');
        }
    }, []);

    const fileInputRef = useRef(null);

    //uniqueを引数として受け取った場合DynamoDBからのデータを取得する
    const [USjsonData, setUSJsonData] = useState("loading...");  //新しいstateを追加
    //const [loading, setLoading] = useState(true);//ローディング状態
    const [loading, setLoading] = useState({
        isEnabled:true,
        message:'データベースに接続中...'
    })
    const [isSessionCleared, setIsSessionCleared] = useState(false);  // sessionStorageがクリアされたかどうか
    const [authList, setAuthList] = useState([]);

    //差し戻し時のフォーム
    const [showModal, setShowModal] = useState(false);
    const [returnMessage, setReturnMessage] = useState('');

    /*申請時のタイプ（承認/差し戻し） */
    const [type, setType] = useState('');
    const [increment,setIncrement] = useState('');

    const [exeflag, setExeflag] = useState(false);
    
    /*S3 file upload */
    const [file, setFile] = useState(null);  // ファイルの状態を管理するためのuseStateフック


    /*権限を保持する変数 */
    const [permission, setPermission] = useState(false);
    const [Designerflag, setDesignerflag] = useState(false);
    const [Designerflag2, setDesignerflag2] = useState(false);
    const [TestReviewerflag, setTestReviewerflag] = useState(false);
    const [TestOperatorflag, setTestOperatorflag] = useState(false);
    const [EquipmentAdminflag, setEquipmentAdminflag] = useState(false);
    const [Adminflag, setAdminflag] = useState(false);

    const [finish, setFinish] = useState(false);

    //現在の保持者
    const [holder,setHolder] = useState('');

    // バリデーションエラーを管理するためのstate
    const [errors, setErrors] = useState({});





    //const [status, setStatus] = useState();
    const [formData, setFormData] = useState({
        /*TEXT*/
        Status: '',
        Name:'',
        Unique: '',
        Serial: '',
        Designer: '',
        DesignReviewer: '',
        DesignApprover: '',
        Designer2: '',
        DesignReviewer2: '',
        DesignApprover2: '',
        TestOperator: '',
        TestReviewer: '',
        TestApprover: '',
        EquipmentAdmin: '',
        TestOperator2: '',
        TestReviewer2: '',
        TestApprover2: '',
        Subject: '',
        Quantity: '',
        ManHours: '',
        DepartmentCode: '',
        Department: '',
        Purpose: '',
        System: '',
        CarModel: '',
        PartNumber: '',
        SoftNumber: '',
        ProjectCode: '',
        Supplement: '',
        Standard: '',
        Rank : '',
        TechnicalReport: '',
        UrgentReason: '',
        Testplan:'',
        /*RADIO*/
        UrgentArrtibute: '',//起票時属性(なし/特急)
        RequestAttribute: '',//依頼属性(依頼/自主)
        TestAttribute: '',//試験属性(電気評価/電波評価/環境評価)
        LocationAttribute: '',//試験場所（社外/社内）
        Novelty: '',
        Cancel: '',//0or1
        /*DATES*/
        Year: '',
        DesignDate: '',
        DesignReviewDate: '',
        DesignApprovalDate: '',
        DesignDate2: '',
        DesignReviewDate2: '',
        DesignApprovalDate2: '',
        TestReviewDate: '',
        TestApprovalDate: '',
        RequestReceivedDate: '',
        TestReviewDate2: '',
        TestApprovalDate2: '',
        StartDate: '',
        EndDate: '',
        ReportDate:'',
        ScheduledReportingDate: '',
        MeetingDate: '',
        TestEndDate: '',
        ReadyDate: '',
        ReturnDate:'',
        /*FILE */
        FilePath: [],
      });

    //DBへ保存されるKEY
    const dataList =[
        'Unique',
        'Name',
        'Serial',
        'Status',
        'Designer',
        'DesignReviewer',
        'DesignApprover',
        'Designer2',
        'DesignReviewer2',
        'DesignApprover2',
        'TestOperator',
        'TestReviewer',
        'TestApprover',
        'EquipmentAdmin',
        'TestOperator2',
        'TestReviewer2',
        'TestApprover2',
        'Subject',
        'Quantity',
        'ManHours',
        'DepartmentCode',
        'Department',
        'Purpose',
        'System',
        'CarModel',
        'PartNumber',
        'SoftNumber',
        'ProjectCode',
        'Supplement',
        'Standard',
        'Rank',
        'TechnicalReport',
        'UrgentReason',
        'Testplan',
        'returnMessage',
        'UrgentArrtibute',
        'RequestAttribute',
        'TestAttribute',
        'LocationAttribute',
        'Novelty',
        'Cancel',
        'DesignDate',
        'DesignReviewDate',
        'DesignApprovalDate',
        'DesignDate2',
        'DesignReviewDate2',
        'DesignApprovalDate2',
        'TestReviewDate',
        'TestApprovalDate',
        'RequestReceivedDate',
        'TestReviewDate2',
        'TestApprovalDate2',
        'StartDate',
        'EndDate',
        'ReportDate',
        'ScheduledReportingDate',
        'MeetingDate',
        'TestEndDate',
        'ReadyDate',
        'Year',
        'ReturnDate',
        /*FILE */
        'FilePath',
    ]

 // 必須項目のリスト
 const Fields = {
    Designer: "設計者",
    DesignApprover: "設計承認者",
    TestOperator:"評価実施者",
    TestReviewer: "実験Ｇ担当者",
    TestApprover: "実験Ｇ承認者",
    EquipmentAdmin: "設備管理者",
    Subject: "件名",
    Quantity: "数量",
    ManHours: "工数",
    DepartmentCode: "部署コード",
    Department: "部署",
    Purpose: "評価の目的",
    System: "システム",
    CarModel: "車種",
    PartNumber: "部品番号",
    SoftNumber: "ソフト番号",
    ProjectCode: "プロジェクトコード",
    Standard: "基準",
    Rank: "ランク",
    UrgentReason:"特急理由",
    /*RADIO*/
    RequestAttribute: '評価区分',//依頼属性(依頼/自主)
    TestAttribute: '評価種類',//試験属性(電気評価/電波評価/環境評価)
    LocationAttribute: '実施場所',//試験場所（社外/社内）
    Novelty: '新規性',
    /*日付*/
    StartDate: '開始予定日',
    EndDate: '終了予定日',
    ScheduledReportingDate: '結果報告予定日',
    ReadyDate: '準備完了予定日',
    UrgentReason: '特急理由',
  };
    //<input date にて過去の日付を入力できないようにする
    // 現在の日付を状態に保存
    /*
    const [minDate, setMinDate] = useState('');
    useEffect(() => {
        // 現在の日付を取得して、minDateに設定
        const today = new Date().toISOString().split('T')[0];
        setMinDate(today); // minDateの状態を更新
    }, []);
*/

    //レンダリング完了後に表示する（コピーボタン用）
    const [isRendered, setIsRendered] = useState(false);
    useLayoutEffect(() => {
      
      const timer = setTimeout(() => {
        setIsRendered(true);
      }, 1000);
  
      return () => clearTimeout(timer); // クリーンアップ
    }, [formData.Unique]);



/**********************************************************************************************/
//API設定
/**********************************************************************************************/
    // タイムアウト付きfetch関数
    async function fetchWithTimeout(url, options = {}, timeout = 5000) {
        const controller = new AbortController();
        const signal = controller.signal;
        const fetchPromise = fetch(url, { ...options, signal });
        const timeoutId = setTimeout(() => {
            controller.abort();
        }, timeout);
        try {
            return await fetchPromise;
        } finally {
            clearTimeout(timeoutId);
        }
    }
    // 再トライ付きAPI呼び出し関数（GET/POST両対応）
    async function fetchAPI(url, options = {}, retries = 2, timeout = 5000) {
        let attempts = 0;
        let lastError = null;
        while (attempts < retries) {
            try {
                const response = await fetchWithTimeout(url, options, timeout);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return await response.json(); // 成功時にJSONデータを返す
            } catch (error) {
                lastError = error;
                attempts += 1;
                console.warn(`Attempt ${attempts} failed: ${error.message}`);
                if (attempts >= retries) {
                    throw lastError;
                }
            }
        }
    }
  
    /**********************************************************************************************/
    //メンバーのリストを取得する関数
    //
    /**********************************************************************************************/
    /*部員、承認者リスト取得 */
    const GetAuthList = async() =>{
        const authListStr = sessionStorage.getItem('authListStr')
        if(authListStr != null){
            console.log("承認者リスト取得済み")
            return;
        }
        console.log("承認者リストを取得")
        setLoading(prevState => ({
            ...prevState,
            isEnabled:true,
            message: "リスト読み込み中..." // メッセージの変更
        }));
        const url = 'https://91irq05y3c.execute-api.ap-northeast-1.amazonaws.com/auth/api';
        const options = {
            method: 'GET', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
        };
        try{
            const json = await fetchAPI(url,options);
            setAuthList(json)
            sessionStorage.setItem('authListStr',JSON.stringify(json));
            console.log("authlist:::",json);//JSON.parse(sessionStorage.getItem('authListStr'));
        }
        catch{
            console.log('auth list取得失敗')
        }finally{
            setLoading(prevState => ({
            ...prevState,
            isEnabled:false,
            }));
        }
    }

    useEffect(() => {
        const authlist = sessionStorage.getItem('authListStr');
        if (authlist && authlist != 'null') { //依頼表力リンク時にNullで生成されるため。その状態でlistに遷移するとmapできずエラーとなるため回避
            setAuthList(JSON.parse(authlist));
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
                message:"取得完了"
            }));
        } else {
            GetAuthList();
        }
    }, []);


    /**********************************************************************************************/
    //Unique番号の依頼書内容を取得する関数
    //
    /**********************************************************************************************/
    // 表示後の処置（データ読み込み）
    useEffect(() => {
        const GetData = async () => {
            setLoading(prevState => ({
                ...prevState,
                isEnabled:true,
                message: "データ取得中..." // メッセージの変更
                }));
            console.log('データベース読み出しAPIを実行開始');
            const queryParams = new URLSearchParams({unique:unique}).toString();
            const url = `https://4576qwzryc.execute-api.ap-northeast-1.amazonaws.com/test/api?${queryParams}`;
            console.log("unique:::"+unique);
            console.log('url:::',url);
            if(unique === ""){
                alert("指定した番号はみつかりません");
                navigate('/list');
            }
            if(unique){
                console.log('unique番号がクエリ送信されている事を認識');
                // "auth"の値を一時的に保存
                const ID = sessionStorage.getItem('ID');
                const User = sessionStorage.getItem('User');
                const Department = sessionStorage.getItem('Department');
                const Room = sessionStorage.getItem('Room');
                const datalist = sessionStorage.getItem('dataList');
                const authlist = sessionStorage.getItem('authListStr');
                // sessionStorage内の全てのデータをクリア
                sessionStorage.clear();
                // "auth" と "name" の値を再設定
                const json = {};
                if (ID !== null) {
                    json['ID'] = ID;
                    json['User'] = User;
                    json['Department'] = Department;
                    json['Room'] = Room;
                    const year = new Date().getFullYear().toString();
                    json['Year'] = year;
                    json['Serial'] = `ADS-EE-****-未確定`;
                    sessionStorage.setItem('dataList',datalist);
                    sessionStorage.setItem('authListStr',authlist);

                    Object.entries(json).map(([key,value]) => {
                        setFormData(prev => ({...prev,[key]:value}));
                        sessionStorage[key]=value;
                    })
                }
                console.log('usestateの内容を初期化');

                //formData,sessionへの書き込み
                dataList.forEach( key => {
                    if(json[key] == null || json[key] == ''){
                        setFormData(prevFormData => ({ ...prevFormData, [key]: null }));
                        sessionStorage[key]= '';
                    }else{
                        setFormData(prevFormData => ({ ...prevFormData, [key]: json[key] }));
                        sessionStorage[key]= json[key];
                    }
                })

                if(unique === "NEW"){
                    console.log('新規作成の場合にStatus番号を付与：１');
                    setFormData(prev => ({
                        ...prev,
                        Status: "1",
                        Designer: ID,
                        Name: User,
                        Unique:"NEW",
                        Cancel:"0",
                      }));
                    sessionStorage.setItem('Designer',ID);
                    sessionStorage.setItem('Status','1');
                    setLoading(prevState => ({
                        ...prevState,
                        isEnabled:false,
                        }));
                }
                else{  
                    console.log('usestateの内容を初期化');
                    console.log("API実行")
                    const options = {
                        method: 'GET', // GETまたはPOST
                        headers: {
                            'Content-Type': 'application/json',
                        },
                    };
                    try {
                        //使用するAWS API Gateway_API_リソースを宣言 
                        const json = await fetchAPI(url,options);
                        setUSJsonData(json); // 取得したデータをstateに保存
                        console.log(json);
                       
    
                        //受信したjsonを展開
                        console.log('受信したjsonを展開');
                        dataList.forEach( key => {
                            if(json[0][key] == null || json[0][key] == ''){
                                setFormData(prevFormData => ({ ...prevFormData, [key]: null}));
                                sessionStorage[key]= '';
                            }else{
                                setFormData(prevFormData => ({ ...prevFormData, [key]: json[0][key] }));
                                sessionStorage[key]= json[0][key];
                            }
                        })
                        // formDataの全てのキーと値を読み取って出力する(先にレンダリングされてしまう)
                        await Object.entries(formData).forEach(([key, value]) => {
                            console.log(`formData.${key}: ${value}`);
                        });
    
                        /*
                        Object.entries(json[0]).forEach(([key, value]) => {
                            console.log(`${key}: ${value}`);
                            if(value == null){
                                setFormData(prevFormData => ({ ...prevFormData, [key]: '' }));
                                sessionStorage[key]= '';
                            }else{
                                setFormData(prevFormData => ({ ...prevFormData, [key]: value }));
                                sessionStorage[key]= value;
                            }
                            
                        });
                        */
                       console.log("setFinishを更新しました");
    
                    } catch (error) {
                        console.error('API呼び出しエラー:', error)
                        alert('API呼び出しエラー:', error)
                    } finally{
                        setLoading(prevState => ({
                            ...prevState,
                            isEnabled:false,
                            }));
                        setFinish(true);
                        console.log("setFinishを更新しました");
                        //document.title = "ADS-EE-" + sessionStorage("Year") + "-" + String(formData.Unique).padStart(4, '0');
                    }
                }
            }

        }
        GetData();
        
    }, [unique]) // 空のdependency arrayを指定して、コンポーネントがマウントされたときに1回だけ呼び出す


    /**********************************************************************************************/
    //新規作成時に折り返しルート（報告ルート）の選択を自動で行う関数
    //申請ルートと同じ人にする処理
    /**********************************************************************************************/
    //ユーザーが選択しない選定項目は、あらかじめ入れておく（ただし、新規作成の時のみ）
    useEffect(()=>{
        if(unique === "NEW"){
            setFormData(prev=>({...prev,Designer2:formData.ID}));
        }
    },[formData.Designer]);
    useEffect(()=>{
        if(unique === "NEW" && authList.length > 0){
            const reviewer = authList.filter(item => item.Role_A_RV === "1").map((item) => (
                item.ID
            ))
            setFormData(prev=>({...prev,TestReviewer:reviewer[0]}));
            setFormData(prev=>({...prev,TestReviewer2:reviewer[0]}));
        }
    },[authList,formData.TestReviewer2]);
    useEffect(()=>{
        if(unique === "NEW" && authList.length > 0){
            const approver = authList.filter(item => item.Role_A_APPD === "1").map((item) => (
                    item.ID
                ))
            setFormData(prev => ({ ...prev, TestApprover: approver[0] }));
            setFormData(prev => ({ ...prev, TestApprover2: approver[0] }));
        }
    },[authList,formData.TestApprover2]);
    /*--------------------------------------------------------------------------*/



    /**********************************************************************************************/
    //ユーザー入力値を常に確認し、変数に保管しておく関数
    //
    /**********************************************************************************************/
    //テキスト入力時の動作
    const handleDataChange = (event) => {
        

        const { name, value } = event.target;
        let val = "";
        if(value){
            val = value;
        }
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: val
        }));
        sessionStorage[name]=val; //セッションへ入力内容を保存

        //戻り側も入力する
        if(name === 'ID'){
            setFormData(prev=>({...prev,Designer2:val}));
            sessionStorage.setItem('Designer2',val);
        }
        else if(name === 'DesignReviewer'){
            setFormData(prev=>({...prev,DesignReviewer2:val}));
            sessionStorage.setItem('DesignReviewer2',val);
        }
        else if(name === 'DesignApprover'){
            setFormData(prev=>({...prev,DesignApprover2:val}));
            sessionStorage.setItem('DesignApprover2',val);
        }
        else if(name === 'TestOperator'){
            setFormData(prev=>({...prev,TestOperator2:val}));
            sessionStorage.setItem('TestOperator2',val);
        }



        //特急かどうかを日付計算する
        if(name === 'StartDate'){
            const today = new Date(); // 現在の日付を取得
            // 1か月後の月と年を計算
            const twoMonthsLater = new Date(today.setMonth(today.getMonth() + 1));
            const twoMonthsLaterYear = twoMonthsLater.getFullYear();
            const twoMonthsLaterMonth = twoMonthsLater.getMonth() + 1; // 月を1から始めるため +1
            // 入力された日付（valをYYYY-MM-DD形式の文字列と仮定）
            const targetDate = new Date(val);
            const targetYear = targetDate.getFullYear();
            const targetMonth = targetDate.getMonth() + 1; // 同様に月は1から始める

            // 翌々月以内の依頼の場合、特急依頼に区分する
            if (twoMonthsLaterYear > targetYear || (twoMonthsLaterYear === targetYear && twoMonthsLaterMonth >= targetMonth)) {
                setFormData(prev => ({
                    ...prev,
                    UrgentArrtibute: '特急'
                }));
                sessionStorage.setItem('UrgentArrtibute','特急');
            }
            else{
                setFormData(prev => ({
                    ...prev,
                    UrgentArrtibute :'通常'
                }));
                sessionStorage.setItem('UrgentArrtibute','通常');
            }
        }
        //依頼評価の場合は担当者を削除する
        if(name === "RequestAttribute" && value === "依頼評価"){
            formData.TestOperator = "";
            sessionStorage.removeItem('TestOperator');
        }
        //環境試験が選択された場合
        if(name === "TestAttribute" && value === "環境"){
            
            const select = authList.filter(item => item.Role_A_ENV === "1")[0];
            console.log("select:::",select);

            setFormData(prev => ({
                ...prev,
                EquipmentAdmin : select.ID
            }));
            sessionStorage.setItem('EquipmentAdmin',select.ID)
        }
        //電波試験が選択された場合
        if(name === "TestAttribute" && value === "電波"){
            
            const select = authList.filter(item => item.Role_A_EMC === "1")[0];
            console.log("select:::",select);

            setFormData(prev => ({
                ...prev,
                EquipmentAdmin : select.ID
            }));
            sessionStorage.setItem('EquipmentAdmin',select.ID)
        }
        //電気試験が選択された場合
        if(name === "TestAttribute" && value === "電気"){
            
            const select = authList.filter(item => item.Role_A_NOI === "1")[0];
            console.log("select:::",select);

            setFormData(prev => ({
                ...prev,
                EquipmentAdmin : select.ID
            }));
            sessionStorage.setItem('EquipmentAdmin',select.ID)
        }

        //未入力エラー処理
        if(errors && Object.keys(errors).length > 0){
            const validationErrors = validate(); // バリデーション関数を呼び出し
            //if (Object.keys(validationErrors).length > 0) {
                let newValidationErrors = { ...validationErrors }; // 
                console.log("name:::",name,value);
                if(value == ""){
                    //KEYを追加する
                    newValidationErrors[name] = Fields[name]+"は必須です"; 
                }
                else if(name == "RequestAttribute" && value == "自主評価"){
                    //KEYを追加する
                    newValidationErrors["TestOperator"] = Fields["TestOperator"]+"は必須です"; 
                }
                else if(name == "RequestAttribute" && value == "依頼評価"){
                    //KEYを削除する
                    console.log("削除:::",name,value);
                    const { ["TestOperator"]: _, ...updatedErrors } = newValidationErrors;
                    newValidationErrors = updatedErrors;
                }
                else{
                    //KEYを削除する
                    console.log("削除:::",name,value);
                    const { [name]: _, ...updatedErrors } = newValidationErrors;
                    newValidationErrors = updatedErrors;
                }
                // エラーが存在する場合、エラーをstateに設定
                setErrors(newValidationErrors);
                console.log('未入力エラー:::::',validationErrors);
                return;
            //}
        }

    };


    /**********************************************************************************************/
    //依頼表の内容をDynamoDBに保存する関数（下書き保存、承認申請、の2つから呼び出される）
    //引数としてJSONを受け取る（usestateのformDataは関数内で編集ができず、最新情報が扱えないため）
    /**********************************************************************************************/
    const handleSave = async(jsondata) => {

        //この処理が完了するまでの間、画面に砂時計（回転）を表示する
        setLoading(prevState => ({
            ...prevState,
            isEnabled:true,
            message: "データ保存中..." // メッセージの変更
            }));

        //DyanamoDB保存用Lambdaを実行するAPI
        const url = 'https://4576qwzryc.execute-api.ap-northeast-1.amazonaws.com/test/api';

        //新規作成の場合は、Unique情報を消す（Lambda側で採番するため）
        if(formData.Unique === "NEW"){
            delete jsondata['Unique'];
        }

        //デバッグ用のコンソール表示（必須ではない）
        console.log('↓↓API送信データ↓↓');
        console.log(jsondata);

        //APIへ接続し、JSONデータをポストする
        const options = {
            method: 'POST', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(jsondata),
        };
        try {
            const data = await fetchAPI(url, options);
            //デバッグ用のコンソール表示（必須ではない）
            console.log("[DEBUG] data:",data);
            console.log("[DEBUG] status:", data.status);
            console.log("[DEBUG] message:", data.message);
            console.log("[DEBUG] savedItem:", data.savedItem);
            console.log("[DEBUG] savedItem.Unique:", data.savedItem.Unique);
            const unique = data.savedItem.Unique;
            //受け取ったデータからUnique番号を抽出し、dataFormにAddする
            sessionStorage.setItem('Unique',unique);
            setFormData(prev=>({...prev,Unique:unique}));


            return [unique,true];

        // エラーハンドリング
        } catch (error) {
            console.error('Error:', error);

        //関数実行完了後の処理
        }finally{
            //砂時計（回転）を無効にする
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
                }));
        }
        

      };

    /**********************************************************************************************/
    //メールを送信する関数
    //引数としてJSONを受け取る（usestateのformDataは関数内で編集ができず、最新情報が扱えないため）
    /**********************************************************************************************/
    const mailsend = async(mailJsonData) => {
        //この処理が完了するまでの間、画面に砂時計（回転）を表示する
        setLoading(prevState => ({
                ...prevState,
                isEnabled:true,
                message: "承認メール送信中..." // メッセージの変更
            }));
        //Mail送信用Lambdaを実行するAPI
        const url = "https://avt2i5idtl.execute-api.ap-northeast-1.amazonaws.com/api";
        
        const jsonData = {
                Unique: mailJsonData['Unique'],//依頼表のユニークNo
                Type: mailJsonData['type'],  // 承認：forward, 差し戻し：backward
                Message: returnMessage,//差し戻しメッセージ
                Increment: mailJsonData['increment'],//インクリメント数
                Year:formData.Year,//依頼表が申請された西暦
            }
        console.log("MailAPIへの送信データ：");
        console.log(jsonData);

        const options = {
            method: 'POST', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(jsonData),
        };
        try {
            const data = await fetchAPI(url, options);
            // JSON データとしてレスポンスを処理
            console.log("RESULT:::", data);
            return true;
        } catch (error) {
            // エラーハンドリング
            console.error('Error:', error);
        }finally{
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
                }));
        }
    }


    /**********************************************************************************************/
    //承認（順方向）を処理する関数
    //Statusの繰り上げ、DB保存とメール送信関数を呼び出す
    /**********************************************************************************************/
    const formRef = useRef(null); // フォーム全体を参照
    const isSave = useRef(false); // 保存ボタンかどうかを判定
    // 保存ボタンがクリックされたとき
    const handleSaveClick = () => {
      // formRef.current が null でないことを確認
      if (formRef.current) {
        isSave.current = true; // 保存ボタンがクリックされた状態に設定
        const inputs = formRef.current.querySelectorAll("input");
        inputs.forEach(input => input.removeAttribute("")); // を無効化
      }
    };

    // 必須項目をバリデーションする関数
    const validate = () => {
        const newErrors = {}; // エラーを格納するオブジェクト
      
        // 必須項目をループでチェック
        Object.entries(Fields).forEach(([field, label]) => {
            if (!formData[field]) {
                console.log("field:::",field);
                if(field == "TestOperator" && formData.RequestAttribute == "依頼評価"){
                    console.log('入力済み:', field, label); // field（プロパティ名）とlabel（値）を表示
                }else if(field == "UrgentReason" && formData.UrgentArrtibute != "特急"){
                    console.log('入力済み:', field, label); // field（プロパティ名）とlabel（値）を表示
                }else{
                    newErrors[field] = `${label}は必須です`; // エラーを記録（動的なフィールド名）
                    console.log('EMPTY:', field, label); // field（プロパティ名）とlabel（値）を表示
                }
                
            }
        });
      
        return newErrors; // 記録したエラーを返す
      };

    const handleSubmit = async(e) => {
        // ページリフレッシュを防ぐ
        e.preventDefault();
        //変数宣言
        let saveres = false;
        let mailres = false;

        //useStateデータの読み出し
        //のちにStatusを更新したいが、formDataの更新は関数内で実行できないため、jsonDataにコピーし、jsonData内のvalueを更新する（API関数（handleSave）へ引数としてjsonDataを渡す）
        const jsonData = {};
        dataList.forEach( key => {
            if(formData[key] == null || formData[key] == ''){
                jsonData[key] = null;
            }else{
                jsonData[key] = formData[key];
            }
        })

        //mail送信用
        const mailJsonData = {};
        //権限の表示
        console.log("formData.ID:::",formData.ID);
        console.log("formData.Designer:::",formData.Designer);
        console.log("permission:::",permission);
        console.log("Designerflag:::",Designerflag);
        console.log("Designerflag2:::",Designerflag2);
        console.log("TestReviewerflag:::",TestReviewerflag);
        console.log("TestOperatorflag:::",TestOperatorflag);
        console.log("EquipmentAdminflag:::",EquipmentAdminflag);
        console.log("Adminflag:::",Adminflag);

        //押したボタンの切り分け用
        const buttonType = e.nativeEvent.submitter.name;
        if(buttonType === 'approve' || buttonType === 'cancel'){
            if(buttonType === 'approve'){
                // 送信ボタンが押された場合はバリデーションを実行
                const validationErrors = validate(); // バリデーション関数を呼び出し
                if (Object.keys(validationErrors).length > 0) {
                // エラーが存在する場合、エラーをstateに設定
                setErrors(validationErrors);
                } else {
                // エラーがない場合、送信処理を実行
                console.log("送信しました:", formData);
                setErrors({}); // エラー状態をリセット
                }
            }
            if(buttonType === 'cancel' && jsonData['Status'] == '8'){
                jsonData['Cancel'] = '1';
            }
            else if(buttonType === 'approve' && jsonData['Status'] == '8'){
                jsonData['Cancel'] = '0';
            }
            let comment;
                if(jsonData['Status'] === '1') comment = '承認依頼を出しますか';
                else if(jsonData['Status'] === '6') comment = '確認完了しますか';
                else if(jsonData['Status'] === '8' && jsonData['Cancel'] === '1') comment = 'キャンセルしますか';
                else comment = '承認しますか';
            const result = window.confirm(comment);
            if (result) {

                //TESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTEST
                // 送信ボタンが押された場合はバリデーションを実行
                const validationErrors = validate(); // バリデーション関数を呼び出し
                if (Object.keys(validationErrors).length > 0) {
                // エラーが存在する場合、エラーをstateに設定
                setErrors(validationErrors);
                console.log('未入力エラー！');
                return;
                } else {
                // エラーがない場合、送信処理を実行
                console.log("送信しました:", formData);
                setErrors({}); // エラー状態をリセット
                }
                //TESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTESTTEST

                /*Statusの現在値を取得 */
                const status = jsonData['Status'];
                //Statusの進み数
                let forward = 1;
                setIncrement(forward);
                mailJsonData['increment'] = forward;
                //ステータスが1かつ、検討者（任意）がBlankの場合、２つ進める。
                if (status === '1' && (formData.DesignReviewer === null  || formData.DesignReviewer === '') || (status === '1' && formData.DesignReviewer && typeof formData.DesignReviewer === 'string' && !formData.DesignReviewer.includes('ADS'))){
                    forward = 2;
                    setIncrement(forward);
                    mailJsonData['increment'] = forward;
                }
                if (status === '11' && (formData.DesignReviewer2 === null  || formData.DesignReviewer2 === '') || (status === '11' && formData.DesignReviewer2 && typeof formData.DesignReviewer2 === 'string' && !formData.DesignReviewer2.includes('ADS'))){
                    forward = 2;
                    setIncrement(forward);
                    mailJsonData['increment'] = forward;
                }
                //キャンセルの場合の処理
                else if(status === '13' && formData.Cancel === '1'){
                    forward = 2;
                    setIncrement(forward);
                    mailJsonData['increment'] = forward;
                }
                /*Statusを更新する */
                const newStatus = ((parseInt(status) || 0) + forward).toString(); // 新しいStatusを計算（NaNを防ぐ）
                setFormData(prev => ({
                    ...prev,
                    Status:newStatus,
                }))
                jsonData['Status'] = newStatus;
                console.log("incrementSTATUS:::"+jsonData['Status']);
                sessionStorage.setItem('Status', newStatus);
                /*DATE*/
                const today = new Date(); // 現在の日付を取得
                const year = today.getFullYear(); // 年を取得
                const month = String(today.getMonth() + 1).padStart(2, '0'); // 月を取得（0から始まるため1を加算し、2桁にパディング）
                const day = String(today.getDate()).padStart(2, '0'); // 日を取得（2桁にパディング）
                const date = `${year}-${month}-${day}`; // YYYY-MM-DD形式で返す
                console.log(date);

                //現在のステータス承認時に必要な日付データを保存する
                //操作権限の確認を行う
                let get_serial = false;//依頼番号の採番をするか
                
                //ステータスに応じた日付の記録を行う
                switch(formData.Status){
                    case '1' :
                        jsonData['DesignDate']=date;
                        sessionStorage.setItem('DesignDate',date);
                        setFormData(prev=>({...prev,DesignDate:date}));
                        break;
                    case '2' :
                        jsonData['DesignReviewDate']=date;
                        sessionStorage.setItem('DesignReviewDate',date);
                        setFormData(prev=>({...prev,DesignReviewDate:date}));
                        break;
                    case '3' :
                        jsonData['DesignApprovalDate']=date;
                        sessionStorage.setItem('DesignApprovalDate',date);
                        setFormData(prev=>({...prev,DesignApprovalDate:date}));
                        break;
                    case '4' :
                        jsonData['TestReviewDate']=date;
                        sessionStorage.setItem('TestReviewDate',date);
                        setFormData(prev=>({...prev,TestReviewDate:date}));
                        get_serial = true;
                        break;
                    case '5' :
                        jsonData['TestApprovalDate']=date;
                        sessionStorage.setItem('TestApprovalDate',date);
                        setFormData(prev=>({...prev,TestApprovalDate:date}));
                        break;
                    case '6' :
                        jsonData['RequestReceivedDate']=date;
                        sessionStorage.setItem('RequestReceivedDate',date);
                        setFormData(prev=>({...prev,RequestReceivedDate:date}));
                        break;
                    case '7' :
                        jsonData['MeetingDate']=date;
                        sessionStorage.setItem('MeetingDate',date);
                        setFormData(prev=>({...prev,MeetingDate:date}));
                        break;    
                    case '8' :
                        jsonData['ReportDate']=date;
                        sessionStorage.setItem('ReportDate',date);
                        setFormData(prev=>({...prev,ReportDate:date}));
                        break;
                    case '9' :
                        jsonData['TestReviewDate2']=date;
                        sessionStorage.setItem('TestReviewDate2',date);
                        setFormData(prev=>({...prev,TestReviewDate2:date}));
                        break;
                    case '10' :
                        jsonData['TestApprovalDate2']=date;
                        sessionStorage.setItem('TestApprovalDate2',date);
                        setFormData(prev=>({...prev,TestApprovalDate2:date}));
                        break;
                    case '11' :
                        jsonData['DesignDate2']=date;
                        sessionStorage.setItem('DesignDate2',date);
                        setFormData(prev=>({...prev,DesignDate2:date}));
                        break;
                    case '12' :
                        jsonData['DesignReviewDate2']=date;
                        sessionStorage.setItem('DesignReviewDate2',date);
                        setFormData(prev=>({...prev,DesignReviewDate2:date}));
                        break;
                    case '13' :
                        jsonData['DesignApprovalDate2']=date;
                        sessionStorage.setItem('DesignApprovalDate2',date);
                        setFormData(prev=>({...prev,DesignApprovalDate2:date}));
                        break;
                    
                    default :
                        alert('データが壊れています。システム管理者へ連絡してください。')
                        return;
                }
                //順方向回覧時は、ReturnDateに空データをいれる
                jsonData['ReturnDate'] = '';
                console.log("Permission:" + permission);
                if(permission){
                    console.log("SAVE");
                    /*
                    Object.entries(jsonData).forEach(([key, value]) => {
                        console.log(`formData.${key}: ${value}`);
                    });
*/                  
                    let uniqueCode;
                    let saveres;
                    let mailres;
                    try{
                        [uniqueCode,saveres] = await handleSave(jsonData); 
                        console.log("Uniqueコードの格納：" + uniqueCode);
                    }catch{
                        console.log("handleSave error");
                    }finally{
                        setType('forward');
                        mailJsonData['type']='forward';
                        mailJsonData['Unique']=uniqueCode;
                        mailres = await mailsend(mailJsonData);
                        console.log("Uniqueコードの格納(2)：" + uniqueCode);

                    }
                    
                    

                    
                    //Formdata clear
                    dataList.forEach( key => {
                        setFormData(prevFormData => ({ ...prevFormData, [key]: '' }));
                    })

                    if(saveres == false ){
                        console.log("DB保存に失敗しました。管理者へご連絡ください");
                        alert('DB保存に失敗しました。管理者へご連絡ください');
                    }
                    if(mailres == false){
                        console.log("承認メール送信に失敗しました。管理者へご連絡ください");
                        alert('承認メール送信に失敗しました。管理者へご連絡ください');
                    }
                    else{
                        console.log("処理を完了しました");
                        sessionStorage.removeItem('dataList');
                        navigate('/mypage');
                    }
                    
                }
                else{
                    alert('ERROR:操作権限がありません。');
                }
            } else {
                console.log("処理をキャンセルしました");
            } 
        }
        else if(buttonType === 'save'){
            
            const response =  handleSave(jsonData);
            console.log("response:",response);
            sessionStorage.removeItem('dataList');
            alert('保存します');
            //navigate('/mypage');
        }
        else if(buttonType === 'return'){
            /*差し戻し時の処理 */
            setShowModal(true);
            // メッセージの取得
            if (returnMessage.trim() === "") {
               
                return;
            }
            //console.log('message;;;'+returnMessage);
        }
        else if(buttonType === 'cancel'){

        }
    };



    /**********************************************************************************************/
    //権限のチェックを行う関数
    //
    /**********************************************************************************************/
    useEffect(() => {
        setFinish(false);
        console.log("権限のチェックを実行");
        Permission(); // formDataが変わるたびに呼び出し
    }, [finish]);
    /*権限確認を行う*/
    const Permission = () => {
        //操作権限の確認を行う
        const ID = sessionStorage.getItem('ID');
        const Status = sessionStorage.getItem('Status');
        switch(Status){
            case '1' :
                if(ID === sessionStorage.getItem('Designer')){
                    setPermission(true);
                    setDesignerflag(true);
                    console.log("Designerに権限を付与しました。");
                }
                setHolder('Designer');
                break;
            case '2' :
                console.log("DesignReviewerに権限を付与しました。");
                if(ID === formData.DesignReviewer) setPermission(true);
                setHolder('DesignReviewer')
                break;
            case '3' :
                if(ID === formData.DesignApprover) setPermission(true);
                setHolder('DesignApprover');
                break;
            case '4' :
                if(ID === formData.TestReviewer){
                    setPermission(true);
                    setTestReviewerflag(true);
                }
                setHolder('TestReviewer');
                break;
            case '5' :
                if(ID === formData.TestApprover) setPermission(true);
                setHolder('TestApprover');
                break;
            case '6' :
                
                if(ID === formData.TestOperator){
                    setPermission(true);
                    //setTestOperatorflag(true);
                } 
                setHolder('TestOperator');
                break;
            case '7' :
                if(ID === formData.EquipmentAdmin) {
                    setPermission(true);
                    setEquipmentAdminflag(true);
                }
                setHolder('EquipmentAdmin');
                break;
            case '8' :
                if(ID === formData.TestOperator2) {
                    setPermission(true);
                    setTestOperatorflag(true);
                }
                setHolder('TestOperator2');
                break;
            case '9' :
                if(ID === formData.TestReviewer2) setPermission(true);
                setHolder('TestReviewer2');
                break;
            case '10' :
                if(ID === formData.TestApprover2) setPermission(true);
                setHolder('TestApprover2');
                break;
            case '11' :
                if(ID === formData.Designer2) setPermission(true);
                setHolder('Designer2');
                setDesignerflag2(true);
                break;
            case '12' :
                if(ID === formData.DesignReviewer2) setPermission(true);
                setHolder('DesignReviewer2');
                break;
            case '13' :
                if(ID === formData.DesignApprover2) setPermission(true);
                setHolder('DesignApprover2');
                break;
            
            default :
                console.log('Statusが取得できません。');
                return;
        }
        /*
        if(sessionStorage.getItem('ID') === "ADS0097410"){
            setPermission(true);
            setDesignerflag(true);
            setDesignerflag2(true);
            setTestReviewerflag(true);
            setTestOperatorflag(true);
            setEquipmentAdminflag(true);
            setAdminflag(true);
        }
            */
        
      };
        

        
    /**********************************************************************************************/
    //差し戻し（逆方向）を処理する関数
    //Statusの繰り下げ、DB保存とメール送信関数を呼び出す
    /**********************************************************************************************/
    const handleFormSubmit = async() => {
        //useStateデータの読み出し
        //Statusを更新したいが、formDataの更新は関数内で実行できないため、
        //jsonDataにコピーし、jsonData内のvalueを更新する（API関数（handleSave）へ引数としてjsonDataを渡す）
        const jsonData = {};
        dataList.forEach( key => {
            if(formData[key] == null || formData[key] == ''){
                jsonData[key] = null;
            }else{
                jsonData[key] = formData[key];
            }
        })
        //mail
        const mailJsonData = {};
        /*Statusの現在値を取得 */
        const status = jsonData['Status'];
        //Statusの戻し数
        let backward = 1;
        setIncrement('-1');
        mailJsonData['increment'] = '-1';
        //ステータスが3かつ、検討者（任意）がBlankの場合、２つ戻す。
        if (status === '3' && (formData.DesignReviewer === null  || formData.DesignReviewer === '') || (status === '3' && formData.DesignReviewer && typeof formData.DesignReviewer === 'string' && !formData.DesignReviewer.includes('ADS'))){
            backward = 2;
            setIncrement('-2');
            mailJsonData['increment'] = '-2';
        }
        if (status === '13' && (formData.DesignReviewer2 === null  || formData.DesignReviewer2 === '') || (status === '13' && formData.DesignReviewer2 && typeof formData.DesignReviewer2 === 'string' && !formData.DesignReviewer2.includes('ADS'))){
            backward = 2;
            setIncrement('-2');
            mailJsonData['increment'] = '-2';
        }
        /*Statusを更新する */
        const newStatus = ((parseInt(status) || 0) - backward).toString(); // 新しいStatusを計算（NaNを防ぐ）
        setFormData(prev =>({
            ...prev,
            Status:newStatus,
        }))
        sessionStorage.setItem('Status', newStatus);
        jsonData['Status'] = newStatus;

        /*督促用に、差し戻し日付をいれる*/
        const today = new Date(); // 現在の日付を取得
        const year = today.getFullYear(); // 年を取得
        const month = String(today.getMonth() + 1).padStart(2, '0'); // 月を取得（0から始まるため1を加算し、2桁にパディング）
        const day = String(today.getDate()).padStart(2, '0'); // 日を取得（2桁にパディング）
        const date = `${year}-${month}-${day}`; // YYYY-MM-DD形式で返す
        jsonData['ReturnDate'] = date;

        //承認権限がある場合は処理を実行する
        if(permission){
            console.log("差し戻しメッセージ:", returnMessage);
            sessionStorage.setItem('returnMessage',returnMessage);
            /*保存*/
            await handleSave(jsonData);
            /*メール送信*/
            setType('backward');
            mailJsonData['type'] = 'backward';
            mailJsonData['Unique'] = formData.Unique;
            await mailsend(mailJsonData);
            setShowModal(false);
            alert('差し戻し完了');
            sessionStorage.removeItem('dataList');
            navigate('/list');
        }
        else{
            alert('ERROR:操作権限がありません。');
        }
        
            
    }

    //差し戻しフォームを閉じる処理
    const handleFormCancel = () => {
        // フォームを閉じる
        setShowModal(false);
        setReturnMessage('');
    };


    /**********************************************************************************************/
    //S3へのファイルのアップロード
    //最大4MBしか対応できないため、今後改善が必要
    /**********************************************************************************************/
    /*S3のファイルアップロード機能*/
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];  // 単一のファイルを選択
        console.log('Selected file:', selectedFile);  // デバッグメッセージ
        setFile(selectedFile);  // 選択されたファイルを状態に設定
      };
    
      const handleUpload = async (event) => {
        if (!file) {  // ファイルが選択されていない場合のチェック
          console.log('ファイルを選択してください。');  // メッセージを設定
          return;  // 処理を終了
        }
        setLoading(prevState => ({
            ...prevState,
            isEnabled:true,
            message: "ファイルのアップロード中..." // メッセージの変更
            }));

        //DB更新用データの作成
        const jsonData = {};
        dataList.forEach( key => {
            if(formData[key] == null || formData[key] == ''){
                jsonData[key] = null;
            }else{
                jsonData[key] = formData[key];
            }
        })
    
        const reader = new FileReader();
        reader.readAsDataURL(file);  // ファイルをBase64にエンコード
    
        reader.onloadend = async () => {
          const base64FileContent = reader.result.split(',')[1];  // Base64文字列を取得
          const fileName = file.name;
          const options = {
            method: 'POST', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                fileName: fileName,
                fileContent: base64FileContent,  // Base64にエンコードされたファイル内容
                serial:formData.Serial,
                year:formData.Year,
            }),
        };
          try {
            const responseData = await fetchAPI('https://yo8ovfph1l.execute-api.ap-northeast-1.amazonaws.com/api', options);            
            /*FilePathをuseStateに保存*/
            const filepath = `${formData.Year}/${formData.Serial}/${fileName}`; 
            console.log(event.target.name);
            console.log(filepath);
            // setFormData で状態更新
            // ファイルパスを追加する関数
            const FPjsondata = {
                    type:event.target.name,
                    name:fileName,
                    path:filepath,
            }
            // 状態更新 (setFormData)
            setFormData(prev => {
                // FilePathがnullまたはundefinedでないかチェックし、配列かどうか確認
                if (prev.FilePath && Array.isArray(prev.FilePath)) {
                    // FilePathに同じ名前のファイルがないかチェック
                    const isFileExists = prev.FilePath.some(item => item.name === fileName);
                    
                    // 同じファイル名があればそのまま何もしない
                    if (isFileExists) {
                        return prev;
                    } else {
                        // 同じファイル名がなければ追加
                        return {
                            ...prev,
                            FilePath: [...prev.FilePath, FPjsondata], // 新しいファイルデータを追加
                        };
                    }
                } else {
                    // prev.FilePathが配列でない場合は、新たに配列として追加
                    return {
                        ...prev,
                        FilePath: [FPjsondata],
                    };
                }
            });

            // jsonData['FilePath']に同様の処理を行う
            if (jsonData['FilePath'] && Array.isArray(jsonData['FilePath'])) {
                // jsonData['FilePath']に同じ名前のファイルがないかチェック
                if (!jsonData['FilePath'].some(item => item.name === fileName)) {
                    jsonData['FilePath'] = [...jsonData['FilePath'], FPjsondata]; // ファイルを追加
                }
            } else {
                // jsonData['FilePath']が配列でない場合、配列として初期化して追加
                jsonData['FilePath'] = [FPjsondata];
            }
            
            console.log(filepath);
            console.log(responseData);
            await handleSave(jsonData);
            console.log('アップロードが成功しました。');  // 成功メッセージ
          } catch (error) {
            console.error(error);
            alert('アップロードに失敗しました。');  // エラーメッセージ
          }finally{
            setFile(null);
            fileInputRef.current.value = '';  // ファイル選択をリセット
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
            }));
          }
        };
    
        reader.onerror = () => {
          console.error('File reading failed');
          alert('ファイルの読み込みに失敗しました。');
        };
      };

    /*S3のダウンロード機能*/
    const handleDownload = async(event) => {
        setLoading(prevState => ({
                ...prevState,
                isEnabled:true,
                message: "データベース接続中..." // メッセージの変更
            }));
        console.log(encodeURIComponent(event.target.value));
        const apiUrl = `https://yo8ovfph1l.execute-api.ap-northeast-1.amazonaws.com/api?filePath=${encodeURIComponent(event.target.value)}`;
        const options = {
            method: 'GET', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
        };
        try{
            const data = await fetchAPI(apiUrl,options);

            // Base64エンコードされたデータをデコード
            const fileContent = atob(data.body); // base64をデコード
            const blob = new Blob([new Uint8Array([...fileContent].map(char => char.charCodeAt(0)))], {
                type: data.contentType
            });
            // ダウンロード処理
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = event.target.value.split('/').pop(); // ファイル名をパスから抽出
            link.click();

        }catch(err){
            console.log(err);
        }finally{
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
            }));
        }

    }
    //ファイル削除
    const handleDelete = async (event) => {
        // 削除するファイルのパスを取得
        const filePath  = event.target.value;
      
        if (!filePath) {
          console.log('削除するファイルパスがありません');
          return;
        }
      
        // ユーザーに削除の確認を促す
        const isConfirmed = window.confirm('本当にこのファイルを削除しますか？'); 
      
        // ユーザーが「OK」を押さなかった場合、削除処理を中断
        if (!isConfirmed) {
          console.log('ファイル削除がキャンセルされました');
          return;
        }
        setLoading(prevState => ({
            ...prevState,
            isEnabled:true,
            message: "データベース更新中..." // メッセージの変更
            }));
        
        //DB更新用データの作成
        const jsonData = {};
        dataList.forEach( key => {
            if(formData[key] == null || formData[key] == ''){
                jsonData[key] = null;
            }else{
                jsonData[key] = formData[key];
            }
        })

        const options = {
            method: 'DELETE', // GETまたはPOST
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filePath: filePath, // 削除するファイルのパスを送信
                serial: formData.Serial,
                year: formData.Year,
            }),
        };
        try {
            // サーバーにファイル削除をリクエスト
            const responseData = await fetchAPI('https://yo8ovfph1l.execute-api.ap-northeast-1.amazonaws.com/api', options);
            console.log(responseData);
        
            // 削除成功後、状態更新
            setFormData((prev) => ({
            ...prev,
            FilePath: prev.FilePath.filter((item) => item.path !== filePath), // 削除したファイルパスを除外
            }));
            // jsonData['FilePath']も更新
            jsonData['FilePath'] = jsonData['FilePath'].filter((item) => item.path !== filePath); // 削除したファイルパスを除外
            await handleSave(jsonData);
            console.log('ファイルの削除が成功しました。'); // 成功メッセージ

        } catch (error) {
            console.error(error);
            alert('ファイルの削除に失敗しました。'); // エラーメッセージ
        }finally{
            setFile(null);
            fileInputRef.current.value = '';  // ファイル選択をリセット
            setLoading(prevState => ({
                ...prevState,
                isEnabled:false,
            }));
        }
      };
      
      


    // 拡張子からアイコン画像のパスを取得する関数
    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase(); // 拡張子を取得
        
        const iconMap = {
        'doc': 'WinWordLogoSmall.scale-140.png',  // Wordファイル
        'docx': 'WinWordLogoSmall.scale-140.png',// Wordファイル
        'xls': 'ExcelLogoSmall.scale-140.png',
        'xlsx': 'ExcelLogoSmall.scale-140.png',
        'xlsm': 'ExcelLogoSmall.scale-140.png',
        'csv': 'ExcelLogoSmall.scale-140.png',
        'ppt': 'PowerPntLogoSmall.scale-140.png',
        'pptx': 'PowerPntLogoSmall.scale-140.png',
        'pptm': 'PowerPntLogoSmall.scale-140.png',
        // その他の拡張子に対応するアイコンを追加可能
        };
    
        return iconMap[extension] || 'default.png'; // デフォルトのアイコン
    };
    
    
      //test
      /*
      const [content, setContent] = useState('');
      const editableDivRef = useRef(null);
  
      useEffect(() => {
          // sessionStorageから初期値を取得
          const savedContent = sessionStorage.getItem('content');
          if (savedContent) {
              setContent(savedContent);
              editableDivRef.current.innerHTML = savedContent; // HTMLを表示
          } else {
              const defaultContent = 'ここに画像やテキストを貼り付けてください。';
              setContent(defaultContent);
              editableDivRef.current.innerHTML = defaultContent; // デフォルト値を表示
          }
      }, []);
  
      const handlePaste = (event) => {
          const items = event.clipboardData.items;
  
          for (let i = 0; i < items.length; i++) {
              if (items[i].kind === 'file') {
                  const file = items[i].getAsFile();
                  const reader = new FileReader();
                  reader.onload = (e) => {
                      const img = `<img src="${e.target.result}" style="max-width: 100%; display: block;" />`;
                      setContent((prevContent) => prevContent + img); // 既存の内容に追加
                      editableDivRef.current.innerHTML += img; // 表示を更新
                  };
                  reader.readAsDataURL(file);
              }
          }
          event.preventDefault();
      };
  
      const handleInput = () => {
          const currentContent = editableDivRef.current.innerHTML;
          setContent(currentContent);
          sessionStorage.setItem('content', currentContent); // 内容をsessionStorageに保存
      };
*/

        /*formDataの内容を表示する */
      const testbutton = () =>{
        Object.entries(formData).forEach(([key, value]) => {
            console.log(`formData.${key}: ${value}`);
        });
        console.log(JSON.stringify(formData.FilePath));
        console.log("errors:",errors);
      }

        /*コピー新規作成 */
        const copybutton = () =>{
            const today = new Date(); // 現在の日付を取得
            const year = today.getFullYear().toString(); // 年を取得
            setFormData(prevState => ({
                ...prevState,
                Unique:"NEW",
                Serial:"ADS-EE-****-未確定",
                Status:"1",
                Designer:sessionStorage.getItem('ID'),/*いまの情報に更新 */
                Designer2:sessionStorage.getItem('ID'),/*いまの情報に更新 */
                Name:sessionStorage.getItem('User'),/*いまの情報に更新 */
                TestOperator: '',
                DesignReviewer: '',
                DesignApprover: '',
                TestOperator2: '',
                DesignReviewer2: '',
                DesignApprover2: '',
                Year:year,
                TechnicalReport:"",
                UrgentReason:"",
                Testplan:"",
                DesignDate: "",
                DesignReviewDate: "",
                DesignApprovalDate: "",
                DesignDate2: "",
                DesignReviewDate2: "",
                DesignApprovalDate2: "",
                TestReviewDate: "",
                TestApprovalDate: "",
                RequestReceivedDate: "",
                TestReviewDate2: "",
                TestApprovalDate2: "",
                ScheduledReportingDate: "",
                MeetingDate: "",
                TestEndDate: "",
                ReturnDate:"",
                FilePath:null,
                EquipmentAdmin:"",
                }));
            setPermission(true);
            setDesignerflag(true);
            handleDataChange({ //設備管理者更新
                target: {
                    name: "TestAttribute",
                    value: sessionStorage.getItem("TestAttribute"),
                }
            });

            const reviewer = authList.filter(item => item.Role_A_RV === "1").map((item) => ( //受付検討者更新
                item.ID
            ))
            setFormData(prev=>({...prev,TestReviewer:reviewer[0]}));
            setFormData(prev=>({...prev,TestReviewer2:reviewer[0]}));

            const approver = authList.filter(item => item.Role_A_APPD === "1").map((item) => ( //受付承認者更新
                    item.ID
                ))
            setFormData(prev => ({ ...prev, TestApprover: approver[0] }));
            setFormData(prev => ({ ...prev, TestApprover2: approver[0] }));




        }

    return(
        <>
        {/*読み込み中の表示*/}
        
        {loading.isEnabled && (
                // ローディング中のスピナーとテキストの表示
                <div className="spinner-overlay">
                    <div className="spinner"></div>
                    <div className="loading-text">{loading.message}</div>
                </div>
            )}

        {/*差し戻し時に新しいフォームを表示*/}
        {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>差し戻し理由を入力してください</h3>
                        <textarea
                            rows="5"
                            cols="50"
                            value={returnMessage}
                            onChange={(e) => setReturnMessage(e.target.value)}
                        / >
                        <br />
                        <button name="return" type="submit" onClick={handleFormSubmit}>差し戻し</button>
                        <button type="button" onClick={handleFormCancel}>キャンセル</button>
                    </div>
                </div>
            )}


        

        <div className='container'>

        {errors && Object.keys(errors).length > 0 && (
        <>
            <div className='error'>
                <p>未入力エラー:</p>
                {/* errorsオブジェクトを展開 */}
                {Object.entries(errors).map(([field, message]) => (
                <p key={field} className='error-list'>・{message}</p> // field（キー）とmessage（エラーメッセージ）を表示
                ))}
            </div>
            
        </>
        )}
        
        {formData.Unique === 'NEW' && (
            <>
                <p className='savestatus'>状態：未保存（※ページを離れる前に保存してください）</p>
            </>
        )}
        {formData.Cancel === '1' && formData.Status !== '14' && (
            <>
                <p className='cancel'>本依頼はキャンセルされました。<br/>内容を確認してください。</p>
            </>

            )}

        {Adminflag && (
        <button className='console-view' name='test'  onClick={testbutton} >usestate表示（console）</button>
        )}
            <h1>評価依頼表</h1>

            <h2>{formData.Serial}</h2>
            <div className='status'>
                現在のステータス：
                {formData.Status === "1" && (
                    <>
                        申請待ち（依頼部署）<br/>
                        <p className='status-comment'>{authList.find(item => item.ID === formData.Designer)?.Name}さんは依頼内容を入力し、承認申請をしてください。</p>
                    </>
                )}
                {formData.Status === "2" && (
                    <>
                        検討待ち（依頼部署）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.DesignReviewer)?.Name}さんは依頼内容を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "3" && (
                    <>
                        承認待ち（依頼部署）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.DesignApprover)?.Name}さんは依頼内容を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "4" && (
                    <>
                        受付待ち (実験G)<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.TestReviewer)?.Name}さんは依頼内容を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "5" && (
                    <>
                        承認待ち (実験G)<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.TestApprover)?.Name}さんは依頼内容を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "6" && (
                    <>
                        確認待ち（評価実施者）<br />
                        <p className='status-comment'>依頼内容が承認されました。<br/>{authList.find(item => item.ID === formData.TestOperator)?.Name}さんは依頼内容を確認してください。<br/><span style={{fontSize:"0.7em"}}>（不備等ある場合は起票者か実験Gにご相談ください）</span></p>
                    </>
                )}
                {formData.Status === "7" && (
                    <>
                        打合せ待ち（設備管理者）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.EquipmentAdmin)?.Name}さんは[6.打合せ内容]を入力し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "8" && (
                    <>
                        評価完了待ち（評価実施者）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.TestOperator)?.Name}さんは[7.評価結果]を入力し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "9" && (
                    <>
                        検討待ち（実験G）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.TestReviewer2)?.Name}さんは[7.評価結果]を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "10" && (
                    <>
                        承認待ち（実験G）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.TestApprover2)?.Name}さんは[7.評価結果]を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "11" && (
                    <>
                        結果確認待ち（依頼部署）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.Designer2)?.Name}さんは[7.評価結果]を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "12" && (
                    <>
                        検討待ち（依頼部署）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.DesignReviewer2)?.Name}さんは[7.評価結果]を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "13" && (
                    <>
                        承認待ち（依頼部署）<br />
                        <p className='status-comment'>{authList.find(item => item.ID === formData.DesignApprover2)?.Name}さんは[7.評価結果]を確認し、承認をしてください。</p>
                    </>
                )}
                {formData.Status === "14" && "完了（試験実施済）"}
                {formData.Status === "15" && (
                    <>
                        中止（試験未実施）<br />
                        <p className='status-comment'>評価はキャンセルされました</p>
                    </>
                )}
                {formData.Status !== "1" && formData.Status !== "2" && formData.Status !== "3" &&
                formData.Status !== "4" && formData.Status !== "5" && formData.Status !== "6" &&
                formData.Status !== "7" && formData.Status !== "8" && formData.Status !== "9" &&
                formData.Status !== "10" && formData.Status !== "11" && formData.Status !== "12" &&
                formData.Status !== "13" && formData.Status !== "14" && formData.Status !== "15" &&
                "不明"}
            </div>
            
            {
                formData.Status === "1" && (
                    <>
                        <p>必要事項を入力し、</p>
                        <p>画面右下の「承認申請」をクリックしてください。</p>
                    </>
                )
            }
        </div>

        {/*フォーム*/}
        <form onSubmit={handleSubmit}>


        <h3>1. 実施形式を選択してください</h3>
        {/*試験区分の選択*/}
        <fieldset>
            <legend>評価区分</legend>
            <div>
                <input type="radio" id='3' name='RequestAttribute' defaultValue='自主評価' checked={formData.RequestAttribute==='自主評価'} onChange={handleDataChange}  disabled={!Designerflag}/>
                <label htmlFor="3">自主評価</label>
            </div>
            <div>
                <input type="radio" id='4' name='RequestAttribute' defaultValue='依頼評価' checked={formData.RequestAttribute==='依頼評価'} onChange={handleDataChange}  disabled={!Designerflag}/>
                <label htmlFor="4">依頼評価</label>
            </div>
            {errors && Object.keys(errors).length > 0 && !formData.RequestAttribute && <p className="error-message">必須項目です</p>}
        </fieldset>
        {/*試験種類の選択*/}
        <fieldset>
            <legend>評価種類</legend>
            <div>
                <input type="radio" id='5' name='TestAttribute' defaultValue='環境' checked={formData.TestAttribute==='環境'} onChange={handleDataChange}  disabled={!Designerflag}/>
                <label htmlFor="5">環境</label>
            </div>
            <div>
                <input type="radio" id='6' name='TestAttribute' defaultValue='電波' checked={formData.TestAttribute==='電波'} onChange={handleDataChange}  disabled={!Designerflag}/>
                <label htmlFor="6">電波</label>
            </div>
            <div>
                <input type="radio" id='7' name='TestAttribute' defaultValue='電気' checked={formData.TestAttribute==='電気'} onChange={handleDataChange}  disabled={!Designerflag}/>
                <label htmlFor="7">電気</label>
            </div>
            {errors && Object.keys(errors).length > 0 && !formData.TestAttribute && <p className="error-message">必須項目です</p>}
        </fieldset>
        {/*実施場所の選択*/}
        <fieldset>
            <legend>実施場所</legend>
            <div>
                <input type="radio" id='8' name='LocationAttribute' defaultValue='社内' checked={formData.LocationAttribute==='社内'} onChange={handleDataChange}  disabled={!Designerflag}/>
                <label htmlFor="8">社内</label>
            </div>
            <div>
                <input type="radio" id='9' name='LocationAttribute' defaultValue='社外' checked={formData.LocationAttribute==='社外'} onChange={handleDataChange}  disabled={!Designerflag}/>
                <label htmlFor="9">社外</label>
            </div>
            {errors && Object.keys(errors).length > 0 && !formData.LocationAttribute && <p className="error-message">必須項目です</p>}
        </fieldset>




        <h3>2.承認ルート</h3>
        <p>★：現在のタスク保持者</p>
        {/*起票時の申請ルート（2） */}
        <div className='root1'>
            <div>
            <h3>依頼部署</h3>

            <div className="form-group">
                <label htmlFor={"設計者"}>{holder === "Designer" && <><div className="star">★</div></>}起票者 <span style={{fontSize:'.5em'}}>申請日：{formData.DesignDate}</span></label>
                <select id="dropdown" name='Designer' value={formData.Designer || ""} onChange={handleDataChange} disabled={!Designerflag}>
                    {
                    authList.filter(item => item.ID === formData.Designer).map((item) => (
                    <option key={item.ID} value={item.ID}>
                        {item.Name}[{item.ID}][{item.Department}]
                    </option>
                    ))}
                </select>
                </div>


                <div className="form-group">
                <label htmlFor={"検討者"}>{holder === "DesignReviewer" && <><div className="star">★</div></>}検討者(任意) <span style={{fontSize:'.5em'}}>検討日：{formData.DesignReviewDate}</span></label>
                <select id="dropdown" name='DesignReviewer' value={formData.DesignReviewer || ""} onChange={handleDataChange} disabled={!Designerflag}>
                    <option value="">-- 選択 --</option>
                    {
                    authList.filter(item => item.ID !== formData.Designer && item.ID !== 'takoyaki').map((item) => (
                    <option key={item.ID} value={item.ID}>
                        {item.Name}[{item.ID}][{item.Department}]
                    </option>
                    ))}
                </select>
                </div>

                <div className="form-group">
                <label htmlFor={"承認者"}>{holder === "DesignApprover" && <><div className="star">★</div></>}承認者(GL以上) <span style={{fontSize:'.5em'}}>承認日：{formData.DesignApprovalDate}</span></label>
                <select id="dropdown" name='DesignApprover' value={formData.DesignApprover || ""} onChange={handleDataChange}  disabled={!Designerflag}>
                    <option value="">-- 選択 --</option>
                    {authList.filter(item => item.Post === "1").map((item) => (
                    <option key={item.ID} value={item.ID}>
                        {item.Name}[{item.ID}][{item.Department}]
                    </option>
                    ))}
                </select>
                {errors && Object.keys(errors).length > 0 && !formData.DesignApprover && <p className="error-message">必須項目です</p>}
                </div>

                {/* テキストボックスの表示を条件付きで行う */}
                {formData.RequestAttribute === '自主評価' && (
                    <div className="form-group">
                    <label htmlFor={"評価実施者"}>{holder === "TestOperator" && <><div className="star">★</div></>}評価実施者 <span style={{fontSize:'.5em'}}>受領日：{formData.RequestReceivedDate}</span></label>
                    <select id="dropdown" name='TestOperator' value={formData.TestOperator || ""} onChange={handleDataChange}  disabled={!Designerflag} required>
                        <option value="">-- 選択 --</option>
                        {authList.map((item) => (
                        <option key={item.ID} value={item.ID}>
                            {item.Name}[{item.ID}][{item.Department}]
                        </option>
                        ))}
                    </select>
                    {errors && Object.keys(errors).length > 0 && !formData.TestOperator && <p className="error-message">必須項目です</p>}
                    </div>
                )}


            </div>

            <div>
                <h3>受付部署（信頼性技術部）</h3>
                {/* テキストボックスの表示を条件付きで行う */}
                {formData.RequestAttribute !== '自主評価' && (
                    <div className="form-group">
                    <label htmlFor={"評価実施者"}>{holder === "TestOperator" && <><div className="star">★</div></>}評価実施者 <span style={{fontSize:'.5em'}}>受領日：{formData.RequestReceivedDate}</span></label>
                    <select id="dropdown" name='TestOperator' value={formData.TestOperator || ""} onChange={handleDataChange}  disabled={!TestReviewerflag}  required={formData.Status == 4}>{/*実験G検討者のみ編集可能*/}
                        <option value="">-- 選択 --</option>
                        {authList.filter(item => item.Role_A_OP === "1").map((item) => (
                        <option key={item.ID} value={item.ID}>
                            {item.Name}[{item.ID}][{item.Department}]
                        </option>
                        ))}
                    </select>
                    </div>
                )}

                <div className="form-group">
                <label htmlFor={"設備管理者"}>{holder === "EquipmentAdmin" && <><div className="star">★</div></>}設備管理者 <span style={{fontSize:'.5em'}}>打合せ完了日：{formData.MeetingDate}</span></label>
                <select id="dropdown" name='EquipmentAdmin' value={formData.EquipmentAdmin || ""} onChange={handleDataChange}  disabled={!Adminflag}>
                    {authList.filter(item => item.ID === formData.EquipmentAdmin).map((item) => (
                    <option key={item.ID} value={item.ID}>
                        {item.Name}[{item.ID}][{item.Department}]
                    </option>
                    ))}
                </select>
                </div>

                <div className="form-group">
                <label htmlFor={"検討者"}>{holder === "TestReviewer" && <><div className="star">★</div></>}検討者 <span style={{fontSize:'.5em'}}>検討日：{formData.TestReviewDate}</span></label>
                <select id="dropdown" name='TestReviewer' value={formData.TestReviewer || ""} onChange={handleDataChange}  disabled={!Adminflag}>
                    {authList.filter(item => item.Role_A_RV === "1").map((item) => (
                    <option key={item.ID} value={item.ID}>
                        {item.Name}[{item.ID}][{item.Department}]
                    </option>
                    ))}
                </select>
                </div>

                <div className="form-group">
                <label htmlFor={"承認者"}>{holder === "TestApprover" && <><div className="star">★</div></>}承認者 <span style={{fontSize:'.5em'}}>承認日：{formData.TestApprovalDate}</span></label>
                <select id="dropdown" name='TestApprover' value={formData.TestApprover || ""} onChange={handleDataChange}  disabled={!Adminflag}>
                    {authList.filter(item => item.Role_A_APPD === "1").map((item) => (
                    <option key={item.ID} value={item.ID}>
                        {item.Name}[{item.ID}][{item.Department}]
                    </option>
                    ))}
                </select>
                </div>








            </div>
            </div>
        
            {/*試験後の報告ルートを表示 */}
            {formData.Status >= 8 && (
                <>
                    <div className='root2'>
                        <div>
                        <h3>依頼部署</h3>
                            <div className="form-group">
                            <label htmlFor={"設計者"}>{holder === "Designer2" && <><div className="star">★</div></>}起票者 <span style={{fontSize:'.5em'}}>申請日：{formData.DesignDate2}</span></label>
                            <select id="dropdown" name='Designer2' value={formData.Designer2 || ""} onChange={handleDataChange} disabled={!Adminflag}>
                                <option value="">-- 選択 --</option>
                                {
                                authList.map((item) => (
                                <option key={item.ID} value={item.ID}>
                                    {item.Name}[{item.ID}][{item.Department}]
                                </option>
                                ))}
                            </select>
                            </div>

                            <div className="form-group">
                            <label htmlFor={"検討者"}>{holder === "DesignReviewer2" && <><div className="star">★</div></>}検討者 <span style={{fontSize:'.5em'}}>検討日：{formData.DesignReviewDate2}</span></label>
                            <select id="dropdown" name='DesignReviewer2' value={formData.DesignReviewer2 || ""} onChange={handleDataChange} disabled={!Designerflag2}>
                                <option value="">-- 選択 --</option>
                                {
                                authList.filter(item => item.ID !== formData.Designer).map((item) => (
                                <option key={item.ID} value={item.ID}>
                                    {item.Name}[{item.ID}][{item.Department}]
                                </option>
                                ))}
                            </select>
                            </div>

                            <div className="form-group">
                            <label htmlFor={"承認者"}>{holder === "DesignApprover2" && <><div className="star">★</div></>}承認者(GL以上) <span style={{fontSize:'.5em'}}>承認日：{formData.DesignApprovalDate2}</span></label>
                            <select id="dropdown" name='DesignApprover2' value={formData.DesignApprover2 || ""} onChange={handleDataChange}  disabled={!Designerflag2}>
                                <option value="">-- 選択 --</option>
                                {authList.filter(item => item.Post === "1").map((item) => (
                                <option key={item.ID} value={item.ID}>
                                    {item.Name}[{item.ID}][{item.Department}]
                                </option>
                                ))}
                            </select>
                            </div>

                            {/* テキストボックスの表示を条件付きで行う */}
                            {formData.RequestAttribute === '自主評価' && (
                                <div className="form-group">
                                <label htmlFor={"評価実施者"}>{holder === "TestOperator2" && <><div className="star">★</div></>}評価実施者 <span style={{fontSize:'.5em'}}>報告日：{formData.ReportDate}</span></label>
                                <select id="dropdown" name='TestOperator2' value={formData.TestOperator2 || ""} onChange={handleDataChange}  disabled={!Adminflag}>
                                    <option value="">-- 選択 --</option>
                                    {authList.map((item) => (
                                    <option key={item.ID} value={item.ID}>
                                        {item.Name}[{item.ID}][{item.Department}]
                                    </option>
                                    ))}
                                </select>
                                </div>
                            )}
                        </div>



                        <div>
                            <h3>受付部署（信頼性技術部）</h3>
                            {/* テキストボックスの表示を条件付きで行う */}
                            {formData.RequestAttribute !== '自主評価' && (
                                <div className="form-group">
                                <label htmlFor={"評価実施者"}>{holder === "TestOperator2" && <><div className="star">★</div></>}評価実施者 <span style={{fontSize:'.5em'}}>報告日：{formData.ReportDate}</span></label>
                                <select id="dropdown" name='TestOperator2' value={formData.TestOperator2 || ""} onChange={handleDataChange}  disabled={!Adminflag} >{/*実験G検討者のみ編集可能*/}
                                    <option value="">-- 選択 --</option>
                                    {authList.filter(item => item.Role_A_OP === "1").map((item) => (
                                    <option key={item.ID} value={item.ID}>
                                        {item.Name}[{item.ID}][{item.Department}]
                                    </option>
                                    ))}
                                </select>
                                </div>
                            )}
                            <div className="form-group">
                            <label htmlFor={"設備管理者"}>{holder === "EquipmentAdmin" && <><div className="star">★</div></>}設備管理者</label>
                            <select id="dropdown" name='EquipmentAdmin' value={formData.EquipmentAdmin || ""} onChange={handleDataChange}  disabled={!Adminflag}>
                                {authList.filter(item => item.ID === formData.EquipmentAdmin).map((item) => (
                                <option key={item.ID} value={item.ID}>
                                    {item.Name}[{item.ID}][{item.Department}]
                                </option>
                                ))}
                            </select>
                            </div>

                            <div className="form-group">
                            <label htmlFor={"検討者"}>{holder === "TestReviewer2" && <><div className="star">★</div></>}検討者 <span style={{fontSize:'.5em'}}>検討日：{formData.TestReviewDate2}</span></label>
                            <select id="dropdown" name='TestReviewer2' value={formData.TestReviewer2 || ""} onChange={handleDataChange}  disabled={!Adminflag}>
                                {authList.filter(item => item.Role_A_RV === "1").map((item) => (
                                <option key={item.ID} value={item.ID}>
                                    {item.Name}[{item.ID}][{item.Department}]
                                </option>
                                ))}
                            </select>
                            </div>

                            <div className="form-group">
                            <label htmlFor={"承認者"}>{holder === "TestApprover2" && <><div className="star">★</div></>}承認者 <span style={{fontSize:'.5em'}}>承認日：{formData.TestApprovalDate2}</span></label>
                            <select id="dropdown" name='TestApprover2' value={formData.TestApprover2 || ""} onChange={handleDataChange}  disabled={!Adminflag}>
                                {authList.filter(item => item.Role_A_APPD === "1").map((item) => (
                                <option key={item.ID} value={item.ID}>
                                    {item.Name}[{item.ID}][{item.Department}]
                                </option>
                                ))}
                            </select>
                            </div>
                        </div>
                    </div>
                </>
            )}
            
            


        
        <div>
            <h3>3.評価内容</h3>
            <div className="form-group">
            <label htmlFor={"件名"}>件名</label>
            <input type='text' name='Subject' value={formData.Subject ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.Subject && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"評価台数"}>評価台数</label>
            <input type='number' name='Quantity' value={formData.Quantity ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.Quantity && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"予想工数"}>予想工数(0.5h単位)
            </label>
            <input type='number' step="0.5" name='ManHours' value={formData.ManHours ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.ManHours && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"試験要領"}>試験要領</label>
            <input type='text' name='Standard' value={formData.Standard ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.Standard && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"部署コード"}>部署コード</label>
            <input type='text' name='DepartmentCode' value={formData.DepartmentCode ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.DepartmentCode && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"評価の目的・狙い"}>評価の目的・狙い</label>
            <textarea name='Purpose' value={formData.Purpose ?? ''} onChange={handleDataChange} rows={5}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.Purpose && <p className="error-message">必須項目です</p>}
            </div>
        </div>
        <div>
            <h3>4.評価品の詳細</h3>
            <div className="form-group">
            <label htmlFor={"システム"}>システム</label>
            <input type='text' name='System' value={formData.System ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.System && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"製品ランク"}>製品ランク</label>
            <input type='text' name='Rank' value={formData.Rank ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.Rank && <p className="error-message">必須項目です</p>}
            </div>
            {/*新規性の選択*/}
            <div>
            <fieldset>
                <legend>新規性</legend>
                <div>
                    <input type="radio" id='10' name='Novelty' value='新規' checked={formData.Novelty==='新規'} onChange={handleDataChange}  disabled={!Designerflag}/>
                    <label htmlFor="10">新規</label>
                </div>
                <div>
                    <input type="radio" id='11' name='Novelty' value='展開' checked={formData.Novelty==='展開'} onChange={handleDataChange}  disabled={!Designerflag}/>
                    <label htmlFor="11">展開</label>
                </div>
                {errors && Object.keys(errors).length > 0 && !formData.Novelty && <p className="error-message">必須項目です</p>}
            </fieldset>
            </div>
            <div className="form-group">
            <label htmlFor={"車種"}>車種</label>
            <input type='text' name='CarModel' value={formData.CarModel ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.CarModel && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"製品品番"}>製品品番</label>
            <input type='text' name='PartNumber' value={formData.PartNumber ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.PartNumber && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"ソフト品番"}>ソフト品番</label>
            <input type='text' name='SoftNumber' value={formData.SoftNumber ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.SoftNumber && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"プロジェクトコード"}>プロジェクトコード</label>
            <input type='text' name='ProjectCode' value={formData.ProjectCode ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.ProjectCode && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor={"補足情報"}>補足情報</label>
            <textarea name='Supplement' value={formData.Supplement ?? ''} onChange={handleDataChange} rows={5} disabled={!Designerflag}/>
            </div>
            
        </div>
        <div>
            <h3>5.評価計画</h3>
            <div className="form-group">
            <label htmlFor="date:">開始予定日</label>
            <input type="date" name={"StartDate"}  value={formData.StartDate ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.StartDate && <p className="error-message">必須項目です</p>}
            </div>

            {/* テキストボックスの表示を条件付きで行う */}
            {formData.UrgentArrtibute === '特急' && (
                    <div>
                        <p>特急依頼となるため理由の記載が必要です</p>
                        <p>※翌々月以降が通常依頼になります</p>
                        <div className="form-group">
                        <label htmlFor={"特急理由"}><h3>特急理由</h3></label>
                        <textarea name='UrgentReason' defaultValue={formData.UrgentReason} onChange={handleDataChange} rows={5}  disabled={!Designerflag}/>
                        {errors && Object.keys(errors).length > 0 && !formData.UrgentReason && <p className="error-message">必須項目です</p>}
                        </div>
                    </div>
                )}
            <br/>
            <div className="form-group">
            <label htmlFor="date:">準備完了予定日</label>
            <input type="date" name={"ReadyDate"}  value={formData.ReadyDate ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.ReadyDate && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor="date:">終了予定日</label>
            <input type="date" name={"EndDate"}  value={formData.EndDate ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.EndDate && <p className="error-message">必須項目です</p>}
            </div>
            <div className="form-group">
            <label htmlFor="date:">結果報告予定日</label>
            <input type="date" name={"ScheduledReportingDate"}  value={formData.ScheduledReportingDate ?? ''} onChange={handleDataChange}  disabled={!Designerflag}/>
            {errors && Object.keys(errors).length > 0 && !formData.ScheduledReportingDate && <p className="error-message">必須項目です</p>}
            </div>
        </div>

        {(formData.Status >= 7 || Adminflag) && (
        <>
            <div>
                <h3>6.打合せ内容</h3>
                <div className="form-group">
                <label htmlFor="date:">打合せ日</label>
                <input type="date" name={"MeetingDate"}  value={formData.MeetingDate ?? ''} onChange={handleDataChange}  disabled={!EquipmentAdminflag} required/>
                </div>
                <div className="form-group">
                <label htmlFor="date:">試験終了予定日</label>
                <input type="date" name={"TestEndDate"}  value={formData.TestEndDate ?? ''} onChange={handleDataChange}  disabled={!EquipmentAdminflag} required/>
                </div>
                <div className="form-group">
                <label htmlFor={"打合せ内容"}>打合せ内容</label>
                <textarea name='Testplan' value={formData.Testplan ?? ''} onChange={handleDataChange} rows={5}  disabled={!EquipmentAdminflag} required/>
                </div>
    
                <div className='file-upload'>
                    <p>評価計画書のアップロード</p>
                    <input type="file" ref={fileInputRef} onChange={handleFileChange} disabled={!EquipmentAdminflag}/>  {/* ファイル選択の入力フィールド */}
                    <button name='testplan' onClick={handleUpload} disabled={!EquipmentAdminflag} type="submit" formNoValidate>アップロード</button>  {/* アップロードボタン */}
                    <p style={{fontSize:"0.8em",margin:"0px"}}>※同じファイル名は上書きされます</p>
                </div>
                {formData.FilePath != null ? (
                        formData.FilePath.map((item, index) => (
                            // 'testplan'の時のみ表示
                            item.type === 'testplan' && (
                            <div key={index} className="downloadFile">
                                <h3>{item.name}</h3>
                                <img src={`/images/${getFileIcon(item.name)}`} alt="file icon" />
                                <button name='download' value={item.path} onClick={handleDownload} type="submit" formNoValidate>ダウンロード</button>
                                {((formData.Status == 7 && EquipmentAdminflag) || Adminflag) && (
                                    <button name='delete' value={item.path} type='submit' onClick={handleDelete} formNoValidate>×</button>
                                )}
                            </div>
                            )
                        ))
                        ) : (
                        <div>アップロードされたファイルはありません</div>
                    )}
            </div>
        </>
        )}

        {(formData.Status >= 8  || Adminflag )&& (
            <>
            <div>
                <h3>7.評価結果</h3>
                <div className="form-group">
                <label htmlFor={"評価報告"}>報告内容（キャンセルの場合はこちらに理由を記載）</label>
                <textarea name='TechnicalReport' defaultValue={formData.TechnicalReport} onChange={handleDataChange} rows={5}  disabled={!TestOperatorflag} required/>
                </div>
    
                <div className='file-upload'>
                    <p>評価報告書のアップロード</p>
                    <input type="file" ref={fileInputRef} onChange={handleFileChange} disabled={!TestOperatorflag}/>  {/* ファイル選択の入力フィールド */}
                    <button name='result' onClick={handleUpload} disabled={!TestOperatorflag} type="submit" formNoValidate>アップロード</button>  {/* アップロードボタン */}
                    <p style={{fontSize:"0.8em",margin:"0px"}}>※同じファイル名は上書きされます</p>
                </div>
                {formData.FilePath != null ? (
                        formData.FilePath.map((item, index) => (
                            // 'testplan'の時のみ表示
                            item.type === 'result' && (
                                <div key={index} className="downloadFile">
                                <h3>{item.name}</h3>
                                <img src={`/images/${getFileIcon(item.name)}`} alt="file icon" />
                                <button name='download' value={item.path} onClick={handleDownload} type="submit" formNoValidate>ダウンロード</button>
                                {((formData.Status == 8 && TestOperatorflag) || Adminflag) && (
                                    <button name='delete' value={item.path} type='submit' onClick={handleDelete} formNoValidate>×</button>
                                )}
                            </div>
                            )
                        ))
                        ) : (
                        <div>アップロードされたファイルはありません</div>
                    )}
            </div>
            </>
        )}


        {/*
        <div>
        <br></br><br></br>
            <p>以下はテスト（工事中）</p>
        <div
            ref={editableDivRef}
            contentEditable="true"
            onInput={handleInput} // 入力内容を更新
            onPaste={handlePaste}
            style={{
                border: '1px solid #aaa',
                borderRadius: '5px',
                padding: '10px',
                width: '320px',
                height: '200px',
                overflow: 'auto',
                resize: 'both', // 幅と高さを可変にする
                minWidth: '150px', // 最小幅を設定
                minHeight: '100px', // 最小高さを設定
            }}
        />
        </div>
        */}


        {/* テキストボックスの表示を条件付きで行う */}
        {formData.Status === '1' && permission && (
            <div>
            <br /><br />
            <button name="save" className='floating-save-button' type="submit">保存</button>
            <button name='approve' className='floating-approve-button' type="submit" >承認申請</button>
            </div>
            )}

            {formData.Status >= 2 && formData.Status != 6 && formData.Status != 7 && formData.Status != 8 && permission && (
            <div>
            <br /><br />
            <button name='return' className='floating-save-button' type="submit" >差し戻し</button>
            <button name='approve' className='floating-approve-button' type="submit" >承認</button>
            </div>
            )}

        {/*試験実施者は確認のみとする*/}
        {formData.Status == 6 && permission &&(
            <div>
            <br /><br />
            <button name='approve' className='floating-approve-button' type="submit" >確認</button>
            </div>
            )}
        {/**/}
        {formData.Status == 7 && permission &&(
            <div>
            <br /><br />
            <button name='approve' className='floating-approve-button' type="submit" >承認</button>
            </div>
            )}
        {/*試験実施中のみ選択肢は差し戻しではなくキャンセルとする*/}
        {formData.Status == 8 && permission &&(
            <div>
            <br /><br />
            <button name='cancel' className='floating-save-button' type="submit" >評価キャンセル</button>
            <button name='approve' className='floating-approve-button' type="submit" >承認</button>
            </div>
            )}
        
        

        </form>

        {isRendered && formData.Unique != "NEW" && (
        <button name='copy' className='floating-copy-button'  onClick={copybutton} >コピーして新規作成</button>
        )}
        </>
    )
}